import { render, staticRenderFns } from "./Loyaltyprogram.vue?vue&type=template&id=4ab09082"
import script from "./Loyaltyprogram.vue?vue&type=script&lang=js"
export * from "./Loyaltyprogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports